import { Drawer } from "antd";
import React from "react";
import OrderDetailLeftPanel from "./OrderDetailLeftPanel";

const OrderListDrawer = ({
  open,
  setOpen,
  orderedItems,
  selectedTableNumber,
  selectedTable,
  setOrdereditems,
  setOpenOtpModal,
  otpData,
  setOtpData,
  OrderData,
  ApiCall,
  orderType,
  handlePlaceGroupOrder
}) => {

  return (
    <>
      <Drawer
        closable={false}
        width={600}
        style={{ zIndex: "999" }}
        open={open}
        onClose={() => setOpen(false)}
      >
        <OrderDetailLeftPanel
          otpData={otpData}
          orderType={orderType}
          setOtpData={setOtpData}
          selectedTableNumber={selectedTableNumber}
          setOpenOtpModal={setOpenOtpModal}
          selectedTable={selectedTable}
          setOpen={setOpen}
          handlePlaceGroupOrder={handlePlaceGroupOrder}
          orderedItems={orderedItems}
          OrderData={OrderData}
          ApiCall={ApiCall}
          setOrdereditems={setOrdereditems}
          open={open}
        />
      </Drawer>
    </>
  );
};

export default OrderListDrawer;
